import { gql } from '@apollo/client';

export const getPanelEstimationQuery = gql`
  query GetPanelEstimation(
    $sessionId: String!
    $request: PanelEstimationRequestInput!
  ) {
    panelEstimation(sessionId: $sessionId, request: $request) {
      numberOfPanels
    }
  }
`;

export default getPanelEstimationQuery;
